<template>

</template>

<script>
    export default {
        name: "FormInputMixin",
        props: {
            value: [String, Number, Boolean, Object],
            caption: String,
            disabled: Boolean,
            required: Boolean
        },
        data: function () {
            return {
                internalValue: null,
                active: false
            }
        },
        watch: {
            value: {
                handler(newVal) {
                    this.internalValue = newVal;
                },
                immediate: true
            },
            internalValue() {
                this.$emit('input', this.internalValue);
            }
        },
        methods: {
            toggleActive() {
                this.active = !this.active;
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../styles/global";
</style>